/**
 * Зависимости
 */
import {DESKTOP_BREAKPOINT} from '../../common/scripts/constants';
import MapFilter from '../../components/yandex-map/infrastructure-checkbox-filter';
import MapRoutes from '../../components/map-routes';
import Observer from '../../common/scripts/observer';
import {Utils} from '../../common/scripts/utils';
import {YANDEX_API_URL} from '@/common/scripts/constants';
import YandexMap from '@/components/yandex-map';

const observer = new Observer();
const activeClass = 'is-active';
const disableClass = 'is-hidden';
const openClass = 'is-open';

class Infrastructure {
    constructor() {
        this.isMobile = Utils.getWindowWidth() < DESKTOP_BREAKPOINT;
        // false - активна вкладка инфраструктуры, true - вкладка маршрутов
        this.routeTab = false;
        // Показ / скрытие карты на мобильных
        this.mapMobileOpen = document.querySelector('.j-infrastructure-mobile-open');
        this.mapMobileWrapper = document.querySelector('.j-infrastructure-mobile-map');
        this.mapMobileClose = document.querySelector('.j-infrastructure-mobile-close');
        this.mapMobileOverlay = document.querySelector('.j-maps-mobile-overlay');
        // Подсветка активного таба
        this.highlight = document.querySelector('.j-tabs-highlight');
        this.controlsWrapper = document.querySelector('.j-map-controls');
        // Переключатель Инфраструктура
        this.infrastructureCheckbox = document.querySelector('.j-map-infrastructure-checkbox');
        this.infrastructureCheckboxItem = this.infrastructureCheckbox?.querySelector('input[type="checkbox"]');
        this.filterListButton = document.querySelector('.j-map-filter-list-open');
        this.filterList = document.querySelector('.j-map-filter-list');
        // Кнопка фильтры - открывающая список фильтров на вкладке инфраструктуры
        this.filterButton = document.querySelector('.j-map-filter-list-toggle');
        this.mapFilterWrapper = document.querySelector('.j-map-filter-list') || null;
        this.mapFiltertarget = document.querySelector('.j-map-filter');
        // Кнопка Маршруты - открывающая список маршрутов на вкладке маршруты
        this.toggleRouteListButton = document.querySelector('.j-map-route-list-toggle');
        this.routeList = document.querySelector('.j-map-routes') || null;
        this.routeButton = document.querySelector('.j-map-route-open');
    }

    init() {
        this._initMapSettings();

        this._initRouteList();
        this._initMapFilter();
        this._initSubscribers();
        this._bindEvents();

        this._setFirstActive();
    }

    _initMapSettings() {
        this.mainMap = document.querySelector('.j-routes-map');
        this.yandexMap = null;
        this.mapRoutes = null;
        this.mapFilter = null;
        this.ymaps = window.ymaps;

        if (this.mainMap) {
            if (this.ymaps) {
                this._initMap(this.mainMap);
            } else {
                Utils.loadScript(YANDEX_API_URL, this._initMap.bind(this, this.mainMap));
            }
        }
    }

    /**
     * Запускаем карту
     */
    _initMap() {
        if (!this.ymaps && !window.ymaps) {
            return;
        }

        this.ymaps = window.ymaps;

        this.ymaps.ready(() => {
            this.yandexMap = new YandexMap(this.ymaps);

            this.yandexMap.init({
                wrapper          : this.mainMap,
                cluster          : true,
                customZoomControl: true,
                disableMobileDrag: false
            });


            observer.subscribe('map:setRoute', (data) => {
                this.yandexMap.setRoute(data);
            });

            observer.subscribe('yandexmapReady', () => {
                this.yandexMap.setCenter(this.yandexMap.settings.center);

                if (this.routeTab) {
                    this._openRoutePage();
                }
            });
        });
    }

    _initRouteList() {
        if (!this.routeList) {
            return;
        }
        this.mapRoutes = new MapRoutes();

        this.mapRoutes.init({
            target: this.routeList
        });
    }

    _initMapFilter() {
        if (!this.mapFilterWrapper) {
            return;
        }

        this.mapFilter = new MapFilter();

        this.mapFilter.init({
            target : this.mapFiltertarget,
            wrapper: this.mapFilterWrapper
        });
    }

    _initSubscribers() {
        if (this.mapMobileOpen && this.mapMobileWrapper) {
            this.mapMobileOpen.addEventListener('click', () => {
                this._toggleMobileMap();

                Utils.bodyFixed();
            });
        }

        if (this.mapMobileClose) {
            this.mapMobileClose.addEventListener('click', () => {
                this._toggleMobileMap();

                Utils.bodyStatic();
            });
        }

        // Слежение за кнопкой открытия вкладки инфраструктуры
        if (this.controlsWrapper && this.filterListButton && this.filterList) {
            this.filterListButton.addEventListener('click', this._openInfrastructurePage.bind(this));
        }

        // Слежение за кнопкой открытия вкладки маршрутов
        if (this.controlsWrapper && this.routeButton && this.routeList) {
            this.routeButton.addEventListener('click', this._openRoutePage.bind(this));
        }

        // Показ или скрытие элементов инфраструктуры
        if (this.infrastructureCheckboxItem && this.filterButton) {
            this.infrastructureCheckboxItem.addEventListener('change', this._openFilterClick.bind(this));

            this.filterButton.addEventListener('click', () => {
                this._toggleFilterButton();
            });
        }

        // Открытие / Закрытие фильтра маршрутов
        if (this.controlsWrapper && this.toggleRouteListButton && this.routeList) {
            this.toggleRouteListButton.addEventListener('click', this._toggleRouteButtons);
        }

        // Подписываемся на событие изменения фильтра инфраструктуры, и на основании полученных данных меняем текст в кнопке
        observer.subscribe('setFilteredArray', (array) => {
            if (array.length > 0) {
                this.filterButton.dataset.closed = `Фильтры <span>${array.length}</span>`;
            } else {
                this.filterButton.dataset.closed = 'Фильтры';
            }
        });
    }

    _bindEvents() {
        const events = ['resize', 'orientationchange'];

        events.forEach((event) => {
            window.addEventListener(event, () => {
                this.isMobile = Utils.getWindowWidth() < DESKTOP_BREAKPOINT;

                if (!this.isMobile) {
                    return;
                }

                Utils.bodyStatic();

                if (this.toggleRouteListButton) {
                    this.routeTab ?
                        this.toggleRouteListButton.classList.add(activeClass) :
                        this.toggleRouteListButton.classList.remove(activeClass);
                }
            });
        });
    }

    /**
     * Меняем подсветку активного таба
     * @param {HTMLElement} activeTag - элемент активного тега
     */
    _changeHighlight(activeTag) {
        if (!this.highlight || !activeTag) {
            return;
        }

        const activeTagWrapper = activeTag.parentNode;
        const activeTagParent = activeTagWrapper?.parentNode;

        const width = activeTagWrapper?.offsetWidth;

        const coordsTab = activeTagWrapper?.getBoundingClientRect();
        const coordsParent = activeTagParent?.getBoundingClientRect();
        // Получаем данные о скролле родителя (актуально на мобилках)
        const parentHorizontalScrolled = activeTagParent?.scrollLeft;

        this.highlight.style.width = `${width}px`;
        this.highlight.style.left = `${Math.abs(coordsParent.left - coordsTab.left) + parentHorizontalScrolled}px`;
    }

    _setFirstActive() {
        const firstElement = this.controlsWrapper?.querySelector(`button.${activeClass}`);

        if (firstElement) {
            setTimeout(() => {
                this._changeHighlight(this.firstElement);
            }, 100);
        }
    }

    /**
     * Открываем страницу с маршрутами
     */
    /* eslint-disable */
    _openRoutePage() {
        // Переключаем кнопки
        this._changeHighlight(this.routeButton);

        if (this.isMobile) {
            this.toggleRouteListButton.classList.add(activeClass);
        }

        this._toggleRouteButtons(true);

        this.routeButton.classList.add(activeClass);
        this.filterListButton.classList.remove(activeClass);

        // Изменяем значение текста кнопки фильтра и чистим фильтрацию
        this.filterButton.dataset.closed = 'Фильтры';
        this._setButtonText(this.filterButton, 'Фильтры');

        observer.publish('cleanArrayFilter');


        if (this.infrastructureCheckbox) {
            this.infrastructureCheckboxItem.checked = false;
            this.mainMap.classList.remove(openClass);
            this.infrastructureCheckbox.classList.remove(activeClass);
            this.filterButton.classList.remove(activeClass);
            this.filterList.classList.remove(openClass);
        }


        if (this.yandexMap) {
            this.yandexMap.toggleAllMarkers(false, false);

            observer.publish('map:routePage', true);

            if (this.yandexMap.settings.route) {
                this.yandexMap.setRoute(this.yandexMap.settings.route);

                this._lightDefaultRoute();
            }

            this.routeTab = true;
        }
    }
    /* eslint-enable */

    /**
     * Открывает страницу с инфраструктурой
     */
    _openInfrastructurePage() {
        this._changeHighlight(this.filterListButton);
        this._toggleRouteButtons('close');
        this.toggleRouteListButton.classList.remove(activeClass);

        this.controlsWrapper.classList.add(disableClass);
        this.filterList.classList.add(activeClass);

        // Переключаем кнопки
        this.filterListButton.classList.add(activeClass);
        this.routeButton.classList.remove(activeClass);

        this.infrastructureCheckbox.classList.add(activeClass);

        this._removeRoute();

        this.infrastructureCheckboxItem.checked = true;
        this._openInfrastructureFilter(true);
    }

    _toggleRouteButtons(state) {
        switch (state) {
            case 'open':
                this.routeList.classList.add(openClass);
                break;
            case 'close':
                this.routeList.classList.remove(openClass);
                break;
            default:
                this.routeList.classList.toggle(openClass);
                break;
        }

        // Изменяем текст в кнопке
        this.routeList.classList.contains(openClass) ?
            this._setButtonText(this.routeButton, this.toggleRouteListButton.dataset.opened) :
            this._setButtonText(this.routeButton, this.toggleRouteListButton.dataset.closed);
    }

    /**
     * Устанавливаем текст в кнопку
     * @param {HTMLElement} button - элемент кнопки
     * @param {string} text - текст который необходимо установить в кнопку
     */
    _setButtonText(button, text) {
        if (!button || !text) {
            return;
        }

        const field = button.querySelector('.j-map-button-text');

        if (field) {
            field.innerHTML = text;
        }
    }

    /**
     * Показ / скрытие мобильной карты
     */
    _toggleMobileMap() {
        if (this.mapMobileOverlay) {
            this.mapMobileOverlay.classList.toggle(activeClass);
        }

        this.mapMobileWrapper.classList.toggle(activeClass);
    }

    _removeRoute() {
        if (this.yandexMap) {
            this.yandexMap.removeRoute();
            this.yandexMap.toggleAllMarkers(false, true);
            this.yandexMap.setCenter(this.yandexMap.settings.center);
        }

        if (this.mapRoutes) {
            this.mapRoutes.removeActiveState();
        }

        observer.publish('map:routePage', false);

        this.routeTab = false;
    }

    /**
     * Клик по чекбоксу фильтра инфраструктуры
     */
    _openFilterClick() {
        this._openInfrastructureFilter(this.infrastructureCheckboxItem.checked);
    }

    /**
     * Показывает / скрывает фильтр
     * @param {boolean} state - открывать или закрывать фильтр
     */
    _openInfrastructureFilter(state) {
        if (state) {
            this.mainMap.classList.add(openClass);
            this.filterButton.classList.add(activeClass);

            this.isMobile ? this.filterList.classList.remove(openClass) : this.filterList.classList.add(openClass);
        } else {
            this.mainMap.classList.remove(openClass);
            this.filterButton.classList.remove(activeClass);
            this.filterList.classList.remove(openClass);
        }
    }

    _toggleFilterButton() {
        this.filterList.classList.toggle(openClass);

        this.filterList.classList.contains(openClass) ?
            this.setButtonText(this.filterButton, this.filterButton.dataset.opened) :
            this.setButtonText(this.filterButton, this.filterButton.dataset.closed);
    }

    /**
     * Ищем и подсвечиваем активный роут
     */
    _lightDefaultRoute() {
        const activeRoute = this.routeList?.querySelector(`[data-route-to="${this.yandexMap.settings.route.to}"]`);

        activeRoute?.classList.add(activeClass);
    }
}

export default Infrastructure;

